import React, { Component } from 'react';

/* Services */
import AuthService from '../services/auth';
import { db } from "../firebase";
import { storage } from '../firebase/firebase';
import Api from '../services/api';

/* Components */
import { Link } from "react-router-dom";
import Slim from './slim/slim.react';
import {PhotoSwipe} from 'react-photoswipe';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import withAuthorization  from '../components/withAuthorization';
import Modal from 'react-modal';

/* Helpers */
import moment from 'moment';
import isEmpty from 'lodash/isEmpty';

/* Assets */
import './messages.css';
import 'react-photoswipe/lib/photoswipe.css';
import send from '../static/vectors/send.svg';
import close from '../static/vectors/close.svg';
import arrow from '../static/vectors/arrow-back.svg';
import gallery from '../static/vectors/gallery.svg';
import checkCircle from '../static/vectors/check-circle.svg';

/* Constants */
import USER_STATUSES from '../constants/userStatuses';
import * as routes from '../constants/routes';

class Messages extends Component {

  constructor(props) {
    super(props);

    this.state = {
      galleryModalOpen: false,
      modalInitialPhoto: 0,
      messages: [],
      photos: [],
      message: '',
      photo: {},
      roomId: '',
      textareaHeight: 40,
      isModalOpen: false,
      modalMessage: '',
    }
  }

  componentDidMount() {
    if(!AuthService.isLoggedIn()) {
      window.location = '/join';
    } else {
      const { room } = this.props;
      this.subscribeToRoom(room);
    }
  }

  componentWillUnmount() {
    const { roomId } = this.state;
    const roomRef = db.getRoomMessages(roomId);
    roomRef.off('child_added');
  }

  startTrialSuperior() {
    (new Api()).post('/startPromoSuperior', {}, AuthService.getAuthCookie())
      .then(response => {
        this.setState({
          isModalOpen: true,
          modalMessage: response.message,
        }, () => {
          this.refreshCurrentUser();
        });
      });
  }

  subscribeToRoom(roomId) {
    let { messages, photos } = this.state;
    const { ucdUser } = this.props;
    let component = this;
    const roomRef = db.getRoomMessages(roomId);
    roomRef.on('child_changed', snap => {
      let { messages, photos } = component.state;
      if(snap.val().content.src.startsWith('gs://')) {
        storage.refFromURL(snap.val().content.src).getDownloadURL()
          .then(url => {
            messages.map((el, i) => {
              if (el.key === snap.key) {
                messages[i].content.src = url;
                messages[i].content.w = snap.val().content.w;
                messages[i].content.h = snap.val().content.h;
                let photoIndex = photos.push(messages[i].content);
                photoIndex--;
                messages[i].photoIndex = photoIndex;
              }
              return el;
            });
            component.setState({
              messages,
              photos,
            });
          });
      } else {
        messages.map((el, i) => {
          if (el.key === snap.key) {
            messages[i].content = snap.val().content;
            messages[i].content.w = snap.val().content.w;
            messages[i].content.h = snap.val().content.h;
            delete photos[el.photoIndex];
          }
          return el;
        });
        component.setState({
          messages,
          photos,
        });
      }
    });
    roomRef.on('child_added', (snap) => {
      const message = snap.val();
      if((ucdUser.status < USER_STATUSES.superior && ucdUser.accountType === 'sugar_parent')){
        message.content = false;
      }
      let format = 'YYYY-MM-DD HH:mm';
      if(moment().dayOfYear() === moment(message.time, 'X').dayOfYear()) {
        format = 'HH:mm';
      }
      if(message.type === 'photo') {
        if(message.content !== 'photo') {
          const originalSrc = message.content.src;
          message.content.src = gallery;
          let photoIndex = -1;
          if (originalSrc.startsWith('gs://')) {
            photoIndex = photos.push(message.content) - 1;
          }
          messages.push({
            key: snap.key,
            photoIndex,
            sender: {
              id: message.senderId,
            },
            content: message.content,
            type: (typeof message.type !== 'undefined') ? message.type : 'text',
            time: moment(message.time, 'X').format(format),
          });
          db.markAllRead(roomId, ucdUser.id);
          this.setState({
            roomId,
            messages
          }, () => {
            this.scrollToBottom();
          });

          if(originalSrc.startsWith('gs://')) {
            storage.refFromURL(originalSrc).getDownloadURL().then((url) => {
              messages.map((el, i) => {
                if (el.key === snap.key) {
                  messages[i].content.src = url;
                  photos[messages[i].photoIndex].src = url;
                }
                return el;
              });
              component.setState({
                messages,
                photos,
              });
            }).catch(error => {
              if (error.code === 'storage/object-not-found') {
                messages.map((el, i) => {
                  if (el.key === snap.key) {
                    messages[i].content.src = gallery;
                    messages[i].content.deleted = true;
                    delete photos[messages[i].photoIndex];
                  }
                  return el;
                });
                component.setState({
                  messages,
                  photos,
                });
              }
            });
          } else {
            messages.map((el, i) => {
              if (el.key === snap.key) {
                messages[i].content.src = gallery;
                messages[i].content.deleted = true;
              }
              return el;
            });
            component.setState({
              messages,
              photos,
            });
          }
        } else {
          message.content = {
            src: gallery,
            w: 200,
            h: 200,
          };
          messages.push({
            key: snap.key,
            photoIndex: -1,
            sender: {
              id: message.senderId,
            },
            content: message.content,
            type: (typeof message.type !== 'undefined') ? message.type : 'text',
            time: moment(message.time, 'X').format(format),
          });

          db.markAllRead(roomId, ucdUser.id);
          this.setState({
            roomId,
            messages
          }, () => {
            this.scrollToBottom();
          });
        }
      } else {
        messages.push({
          key: snap.key,
          sender: {
            id: message.senderId,
          },
          content: message.content,
          type:(typeof message.type !== 'undefined')?message.type:'text',
          time: moment(message.time, 'X').format(format),
        });

        db.markAllRead(roomId, ucdUser.id);
        this.setState({
          roomId,
          messages
        }, ()=> {
          this.scrollToBottom();
        });
      }
    });
  }

  scrollToBottom = () => {
    this.messagesEnd.scrollIntoView({ behavior: "smooth" });
  };


  handleInputChange(e) {
    this.setState({
      message: e.target.value,
      textareaHeight: e.target.scrollHeight,
    });
  }

  sendMessage() {
    const { message, photo } = this.state;
    const { ucdUser: user, room, user: conversationBuddy } = this.props;
    db.doSendMessage(room, user, conversationBuddy.id,  message, photo, moment().format('X'));
    this.setState({
      message: '',
      photo: {},
      textareaHeight: 40,
    });
  }

  clearPhoto() {
    this.setState({
      photo: {},
    })
  }

  deletePhoto(key) {
    const { roomId } = this.state;
    const photoRef = storage.ref(`${roomId}/${key}/image`);
    const messageRef = db.getRef(`rooms/${roomId}/messages/${key}`);

    photoRef.delete().then(() => {
      messageRef.update({
        content: {
          src: gallery,
          w: 200,
          h: 200,
          deleted: true,
        }
      });
    }).catch((error) => {
      console.error(error);
    });
  }

  refreshCurrentUser() {
    const { authUser, onSetAuthUser } = this.props;
    (new Api()).get('/users/current', {}, AuthService.getAuthCookie())
      .then(response => {
        onSetAuthUser(authUser, response.user);
      });
  }

  handleBase64(formdata, progress, success, failure, slim) {
    let photo = {
      src: slim.dataBase64.output.image,
      w: slim.dataBase64.output.width,
      h: slim.dataBase64.output.height,
    };
    this.setState({ photo }, () => {success("upload done");slim.remove()});
  }

  render() {
    const { messages, message, photo, textareaHeight, roomId, galleryModalOpen, modalInitialPhoto, photos, isModalOpen, modalMessage } = this.state;
    const { ucdUser, onClose, onBack, user: conversationBuddy, onChatDrawerOpen } = this.props;

    return (
      <div className="container messages">
        <div className="row title">
          <div className="col col-12">
          <button
            className="btn back"
            onClick={() => {
                const roomRef = db.getRoomMessages(roomId);
                roomRef.off('child_added');
                onBack();
              }
            }
          >
            <img
              src={arrow}
              alt="back"
            />
          </button>
            <Link
              to={`/member/${conversationBuddy.name}`}
              onClick={() => {onChatDrawerOpen(false, false)}}
            >
              <div className="image" style={{
                backgroundImage: `url('${conversationBuddy.photo_url}')`,
              }} />
              <div className="name">
                {conversationBuddy.name}
              </div>
            </Link>
          <button
            className="btn close"
            onClick={() => {
                const roomRef = db.getRoomMessages(roomId);
                roomRef.off('child_added');
                onClose();
              }
            }
          >
            close
          </button>
        </div>
        </div>
        <div className="row">
          {(ucdUser.status < USER_STATUSES.superior && ucdUser.accountType === 'sugar_parent') && !!ucdUser.usedTrialSuperior &&
            <div className="col col-12 upgrade-info">
              <Link to={'/upgrade'}>
                Please upgrade to send messages
              </Link>
            </div>
          }
          {(ucdUser.status < USER_STATUSES.superior && ucdUser.accountType === 'sugar_parent') && !ucdUser.usedTrialSuperior &&
            <div className="col col-12 upgrade-info">
              <a
                onClick={() => {this.startTrialSuperior()}}
              >
                Claim your free week of superior
              </a>
            </div>
          }
          <div className="container chat-box">
            <div className="row">
            {messages.map((message, i) => (
              <div key={i} className={`col col-12 ${(message.sender.id === ucdUser.name)?'right':'left'}`}>
                <div className="row">
                  <div className="col col-auto meta"><span className="name">{(message.sender.id !== ucdUser.name) && message.sender.id}</span> {message.time}</div>
                </div>
                <div className="row">
                  <div className="col col-auto message">
                    {message.content === false && (message.sender.id !== ucdUser.name) && message.sender.id && !!ucdUser.usedTrialSuperior && <Link to={routes.UPGRADE}>Upgrade to read</Link>}
                    {message.content === false && (message.sender.id === ucdUser.name) && message.sender.id && !!ucdUser.usedTrialSuperior && <Link to={routes.UPGRADE}>Upgrade to send</Link>}
                    {message.content === false && (message.sender.id !== ucdUser.name) && message.sender.id && !ucdUser.usedTrialSuperior && <a onClick={() => {this.startTrialSuperior()}}>Claim your free trial to read</a>}
                    {message.content === false && (message.sender.id === ucdUser.name) && message.sender.id && !ucdUser.usedTrialSuperior && <a onClick={() => {this.startTrialSuperior()}}>Claim your free trial to send</a>}
                    {message.type === 'text' && typeof message.content === 'string' && message.content}
                    {message.type === 'photo' && message.content &&
                    <div
                      className={'photo-container'}
                      onClick={() => {if(message.photoIndex >= 0) {this.setState({galleryModalOpen: true, modalInitialPhoto: message.photoIndex})}}}
                      style={{
                        backgroundImage: `url(${message.content.src})`,
                      }}
                    >
                      {message.content.deleted && <span>Image was deleted.</span>}
                      {message.sender.id === ucdUser.name && !message.content.deleted && <button
                        className="btn"
                        onClick={(e) => {e.stopPropagation();this.deletePhoto(message.key)}}
                      >
                        <img
                          src={close}
                          alt={'Close'}
                        />
                      </button>}
                    </div>
                    }
                    </div>
                </div>
              </div>
            ))}
            <div
              className="end"
              ref={(el) => {this.messagesEnd = el;}}
            />
            </div>
          </div>
        </div>
        <div
             className="row input-message">
            <div className="input col col-10">
              {isEmpty(photo) &&
              <textarea
              onChange={(e) => {this.handleInputChange(e)}}
              style={{
                height: `${textareaHeight}px`,
              }}
              name="message"
              value={message}
            />}
              {!isEmpty(photo) &&
              <div className={'photo-container'}
                   style={{backgroundImage: `url(${photo.src})`}}
              >
                <button
                  className="btn"
                  onClick={() => {this.clearPhoto()}}
                >
                  <img
                     src={close}
                     alt={'Close'}
                  />
                </button>
              </div>}
          </div>
          <div className="button col col-2">
            <button
              className="btn send"
              disabled={(ucdUser.status < USER_STATUSES.superior && ucdUser.accountType === 'sugar_parent') || (message.length === 0 && isEmpty(photo))}
              onClick={() => {this.sendMessage()}}
            >
              <img
                src={send}
                alt="send"
              />
            </button>
            <button
              className="btn gallery"
            >
              <img
                src={gallery}
                alt="gallery"
              />
              <Slim
                    minSize={ { width:400, height:400 } }
                    uploadBase64="true"
                    jpegCompression={70}
                    instantEdit="true"
                    push="true"
                    service={ this.handleBase64.bind(this) }
              >
              </Slim>
            </button>
          </div>
        </div>
        {photos.length > 0 &&
          <PhotoSwipe isOpen={galleryModalOpen} items={photos} options={{bgOpacity: 0.7, shareEl: false, index: modalInitialPhoto}} onClose={() => {this.setState({galleryModalOpen: false})}}/>}
        <Modal
          isOpen={isModalOpen}
          onRequestClose={() => {this.closeModal()}}
          contentLabel="Example Modal"
          ariaHideApp={false}
          style={{
            content: {
              top: '50%',
              bottom: 'auto',
              left: '50%',
              right: 'auto',
              transform: 'translate(-50%, -50%)',
            }
          }}
        >
          <div className="content text-center">
            <img src={checkCircle} alt="check" />
            <div className="message">{modalMessage}</div>
            <button onClick={() => {this.closeModal()}}> Close X</button>
          </div>
        </Modal>
    </div>
    )
  }
}

const mapStateToProps = (state, props) => ({
  ...props,
  ucdUser: state.sessionState.ucdUser,
  authUser: state.sessionState.authUser,
});

const mapDispatchToProps = (dispatch) => ({
  onClose: () => dispatch({ type: 'SET_OPEN_DRAWER', openRoom: false, openChatDrawer: false }),
  onBack: () => dispatch({ type: 'SET_OPEN_ROOM', openRoom: false, openChatDrawer: true }),
  onSetAuthUser: (authUser, ucdUser) => dispatch({ type: 'AUTH_USER_SET', authUser, ucdUser }),
  onChatDrawerOpen: (openChatDrawer, openRoom) => dispatch({ type: 'SET_OPEN_DRAWER', openChatDrawer, openRoom }),
});

const authCondition = (authUser) => !!authUser;

export default compose(withAuthorization(authCondition), connect(mapStateToProps, mapDispatchToProps))(Messages);


// WEBPACK FOOTER //
// ./src/components/messages.js